import { z } from "zod";

/** Estrategia de deduplicacao. */
export const duplicateStrategySchema = z.enum(["skip", "update", "create_always"]);
export type DuplicateStrategy = z.infer<typeof duplicateStrategySchema>;

/** Modo de formatacao do nome do paciente. */
export const nameFormatSchema = z.enum(["original", "titlecase", "uppercase"]);
export type PatientNameFormat = z.infer<typeof nameFormatSchema>;

/**
 * Registro normalizado pelo cliente. Server recebe ja pronto pro insert.
 * Todos os campos sao opcionais exceto `name`.
 */
export const patientImportRecordSchema = z.object({
  name: z.string().trim().min(1).max(200),
  email: z.string().trim().max(200).optional(),
  phone: z.string().trim().max(20).optional(),
  landline: z.string().trim().max(20).optional(),
  birthDate: z.string().optional(), // ISO "YYYY-MM-DD"
  document: z.string().trim().max(20).optional(), // CPF em digitos
  identifier: z.string().trim().max(50).optional(),
  sex: z.enum(["M", "F"]).optional(),
  address: z.string().trim().max(300).optional(),
  addressNumber: z.string().trim().max(20).optional(),
  addressComplement: z.string().trim().max(100).optional(),
  neighborhood: z.string().trim().max(100).optional(),
  city: z.string().trim().max(100).optional(),
  state: z.string().trim().max(2).optional(),
  zipCode: z.string().trim().max(10).optional(),
  profession: z.string().trim().max(100).optional(),
  clinicalRecordNumber: z.string().trim().max(50).optional(),
  howDidMeet: z.string().trim().max(100).optional(),
  insurancePlanName: z.string().trim().max(120).optional(),
  insurancePlanNumber: z.string().trim().max(50).optional(),
  motherName: z.string().trim().max(120).optional(),
  notes: z.string().trim().max(5000).optional(),
  active: z.boolean().optional(),
});
export type PatientImportRecord = z.infer<typeof patientImportRecordSchema>;

/** Teto de registros por requisição. Não é limite de planilha, é limite de UMA chamada HTTP: o
 *  importador roda até 4 `findFirst` de deduplicação por registro antes de gravar (ver
 *  routers/import.ts), então 200 mil registros — o cap anterior — emitiam da ordem de 1 milhão de
 *  queries segurando transação por chunk, num corpo JSON de dezenas de MB. Arquivo maior que isso
 *  deve ser dividido, ou o import deve virar job assíncrono (BullMQ já existe no projeto). */
export const IMPORT_MAX_RECORDS = 10_000;

export const patientImportInputSchema = z.object({
  records: z
    .array(patientImportRecordSchema)
    .min(1)
    .max(IMPORT_MAX_RECORDS, `Máximo de ${IMPORT_MAX_RECORDS} registros por importação — divida o arquivo`),
  duplicateStrategy: duplicateStrategySchema.default("skip"),
});
export type PatientImportInput = z.infer<typeof patientImportInputSchema>;

export type PatientImportResult = {
  created: number;
  updated: number;
  skipped: number;
  errors: number;
  errorDetails: string[];
  totalProcessed: number;
};
